import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { LANGUAGE_COUNTRY_CODES } from '../../constants/Languages';

const LanguageFlag = ({ languageCode, size = '1rem' }) => {
  const countryCode = LANGUAGE_COUNTRY_CODES[languageCode];

  if (!countryCode) {
    return <span aria-hidden="true">🏳️</span>;
  }

  return (
    <ReactCountryFlag
      aria-label={languageCode}
      countryCode={countryCode}
      svg
      style={{
        width: size,
        height: size,
        lineHeight: 1,
        flexShrink: 0,
      }}
    />
  );
};

export default LanguageFlag;